import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'template-menu',
    templateUrl: './template-menu.component.html',
    styleUrls: ['./template-menu.component.scss'],
    standalone: false
})
export class TemplateMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input() template;

}
